// fmt: Format address segment
const fmt = (segment, comma = false) => {
    if (!segment) {
        return '';
    }

    return `${segment}${comma ? ', ' : ' '}`;
};

const isNineDigitZip = (postalCode) => {
    if (!postalCode) {
        return false;
    }

    return postalCode.length === 9
        || (postalCode.length === 10 && postalCode.charAt(5) === '-');
};

// TODO: Handle non-US postal codes better, or only do this formatting if the listing is in the US
// Hyphenates a 9-digit ZIP if it is missing a hyphen.
const formatPostalCode = (postalCode) => {
    if (!postalCode) {
        return '';
    }

    if (postalCode.length === 9) {
        return [
            postalCode.slice(0, 5),
            '-',
            postalCode.slice(5),
        ].join('');
    }

    return postalCode;
};

// Converts a 9-digit ZIP to a 5-digit zip
// TODO: Handle non-US postal codes better, or only do this formatting if the listing is in the US
const nineDigitZipToFiveDigit = (postalCode) => {
    if (!postalCode) {
        return '';
    }

    if (isNineDigitZip(postalCode)) {
        return postalCode.substring(0, 5);
    }

    return postalCode;
};

const getGoogleMapsLink = (street, street2, street3, city, state, postalCode) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    `https://www.google.com/maps/search/?api=1&query=${
        // eslint-disable-next-line max-len
        encodeURIComponent(`${fmt(street)}${fmt(street2)}${fmt(street3)}${fmt(city, true)}${fmt(state)}${nineDigitZipToFiveDigit(postalCode)}`)}`;

export {
    getGoogleMapsLink,
    formatPostalCode,
    isNineDigitZip,
    nineDigitZipToFiveDigit,
};
